export default __webpack_public_path__ + "static/media/logo_dark.78fe42d0.png";